import { useSuspenseQuery } from '~/services'
import { DailyUsage, mergeDailyUsages } from '~/features/usage/utils'

type BotAiSpend = {
  workspaceId: string
  botId: string
  startDate: string
  endDate: string
}

export function useBotDailyAiSpend({ workspaceId, botId, startDate, endDate }: BotAiSpend) {
  const { data: dailyOpenAiUsage } = useSuspenseQuery(
    'workspaces_/$workspaceId_/usage/activities/$type/daily/$startDate/$endDate',
    {
      type: 'openai_spend',
      workspaceId,
      startDate,
      endDate,
    }
  ) as { data: DailyUsage[] }

  const { data: dailyBingUsage } = useSuspenseQuery(
    'workspaces_/$workspaceId_/usage/activities/$type/daily/$startDate/$endDate',
    {
      type: 'bing_search_spend',
      workspaceId,
      startDate,
      endDate,
    }
  ) as { data: DailyUsage[] }

  const filteredOpenAiUsage = dailyOpenAiUsage.filter((usage) => usage.metadata?.botId === botId)

  const dailyAiSpendUsage = mergeDailyUsages(
    filteredOpenAiUsage,
    dailyBingUsage.filter((usage) => usage.metadata?.botId === botId)
  )

  return { dailyAiSpendUsage }
}
